export default __webpack_public_path__ + "46eba4cf89618226dbd2cf09495281d1.svg";